import { Fragment } from "react";
import InputEmail from "./InputEmail";
import InputString from "./InputString";
import InputTextArea from "./InputTextArea";
import Notification from "../Notification";
import PhoneNumberInput from "./InputPhone";
import InputOTP from "./InputOTP";
import FileUpload from "./FileUpload";
import InputSelect from "./InputSelect";
import InputAPISelect from "./InputAPISelect";
import Location from "../Location";
import InputCheckbox from "./InputCheckbox";
import InputRangeSlider from "./InputRangeSlider";
import ComponentField from "./ComponentField";
import InputNumnber from "./InputNumber";
import InputSwitch from "./InputSwitch";
import InputRating from "./InputRating";

const formatId = (label) => {
  return label && label.toLowerCase().replaceAll(" ", "-");
};

const formElements = (
  { id, data },
  onChangeHandler,
  errors,
  resendOtp,
  resendOtpTime,
  onKeyPress
) => {
  const { elementConfigs, value } = data;

  const { type, containerClass, fieldLabel, fieldLabelClass, className } =
    elementConfigs;
  let element = null;

  switch (type) {
    case "string":
      element = (
        <InputString
          {...elementConfigs}
          id={id}
          value={value}
          onChangeHandler={onChangeHandler}
          formatId={formatId}
        />
      );
      break;

    case "number":
      element = (
        <InputNumnber
          {...elementConfigs}
          id={id}
          value={value}
          onChangeHandler={onChangeHandler}
          formatId={formatId}
        />
      );
      break;

    case "email":
      element = (
        <InputEmail
          {...elementConfigs}
          id={id}
          value={value}
          onChangeHandler={onChangeHandler}
          formatId={formatId}
        />
      );
      break;

    case "textarea":
      element = (
        <InputTextArea
          {...elementConfigs}
          id={id}
          value={value}
          onChangeHandler={onChangeHandler}
          formatId={formatId}
        />
      );
      break;

    case "phone":
      element = (
        <PhoneNumberInput
          {...elementConfigs}
          id={id}
          value={value}
          onChangeHandler={onChangeHandler}
        />
      );
      break;

    case "switch":
      element = (
        <InputSwitch
          {...elementConfigs}
          id={id}
          onChangeHandler={onChangeHandler}
          formatId={formatId}
          value={value}
        />
      );
      break;

    case "otp":
      element = (
        <InputOTP
          {...elementConfigs}
          id={id}
          onChangeHandler={onChangeHandler}
          value={value}
          formatId={formatId}
          resendOtp={resendOtp}
          resendOtpTime={resendOtpTime}
        />
      );
      break;

    case "file":
      element = (
        <FileUpload
          {...elementConfigs}
          imageApiUrl={value}
          imageViewClass={className}
          onFileSelectSuccess={(file) => {
            onChangeHandler(file, id);
          }}
          onFileSelectError={({ error }) => alert(error)}
        />
      );

      break;

    case "select":
      element = (
        <InputSelect
          {...elementConfigs}
          id={id}
          value={value}
          onChangeHandler={onChangeHandler}
          formatId={formatId}
        />
      );
      break;

    case "api-select":
      element = (
        <InputAPISelect
          {...elementConfigs}
          id={id}
          value={value}
          onChangeHandler={onChangeHandler}
          formatId={formatId}
        />
      );
      break;

    case "checkbox":
      element = (
        <InputCheckbox
          {...elementConfigs}
          id={id}
          value={value}
          onChangeHandler={onChangeHandler}
          formatId={formatId}
        />
      );
      break;

    case "location":
      element = (
        <Location
          {...elementConfigs}
          value={value}
          onLocationSelect={(location) => onChangeHandler(location, id)}
        />
      );
      break;

    case "range-slider":
      element = (
        <InputRangeSlider
          id={id}
          value={value}
          formatId={formatId}
          {...elementConfigs}
          onChange={(value) => onChangeHandler(value, id)}
        />
      );
      break;

    case "rating":
      element = (
        <InputRating
          id={id}
          value={value}
          formatId={formatId}
          {...elementConfigs}
          onChange={(value) => onChangeHandler(value, id)}
        />
      );
      break;

    case "component-field":
      element = <ComponentField {...elementConfigs} />;
      break;
    default:
      return null;
  }

  return (
    <div
      key={id}
      className={`form-element-container ${
        containerClass ? containerClass : ""
      }`}
      onKeyDown={onKeyPress}
    >
      {fieldLabel && <div className={fieldLabelClass}>{fieldLabel}</div>}

      {element}
      {errors && (
        <Fragment>
          {errors[id] && (
            <Notification type="required" message={errors[id]} image={false} />
          )}
        </Fragment>
      )}
    </div>
  );
};

export default formElements;
